module.exports = __webpack_public_path__ + "img/confirmed-verify.448f7380.svg";